import { NewReportAllocatedAndSubsidies42Component } from "../../../components/SupportSystem/Reports/NewReportAllocatedAndSubsidies42Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ReportAllocatedAndSubsidies42Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <NewReportAllocatedAndSubsidies42Component/>
            <Footer />
        </div>   
        // 
    )
    
}